<label for="selectTarget" style="font-weight: bold; color: #719eb6">Annotations:</label>
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <p-checkbox
          [ngModel]="displayAnnotations"
          (ngModelChange)="displayAnnotationsChange.emit($event)"
          [binary]="true"
          [style]="{'color': '#719eb6'}"
          inputId="displayAnnotations"
        />
        <label for="displayAnnotations" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">All Annotations</label>
        <p-checkbox
          class="ms-2"
          [ngModel]="displayAutomaticAnnotations"
          (ngModelChange)="displayAutomaticAnnotationsChange.emit($event)"
          [binary]="true"
          [style]="{'color': '#719eb6'}"
          inputId="displayAutomaticAnnotations"
        />
        <label for="displayAutomaticAnnotations" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">Automatic Annotations</label>
        <p-checkbox
          class="ms-2"
          [ngModel]="displayUserAnnotations"
          (ngModelChange)="displayUserAnnotationsChange.emit($event)"
          [binary]="true"
          [style]="{'color': '#719eb6'}"
          inputId="displayUserAnnotations"
        />
        <label for="displayUserAnnotations" style="font-weight: bold; color: #719eb6; margin-left: 0.5rem">User Annotations</label>
      </div>
      <div class="card-body">
        <div class="annotation-list" style="height: 200px; overflow-y: auto;">
          @if (automaticAnnotations().length > 0) {
            <div class="mb-2">
              <div class="fw-bold mb-1" style="color: #719eb6">Automatic Annotations</div>
              @for(annotation of automaticAnnotations(); track $index) {
                <div class="d-flex align-items-center justify-content-between p-2 border-bottom">
                  <div class="d-flex align-items-center">
                    <p-checkbox
                      [ngModel]="isAnnotationDisplayed(annotation)"
                      [binary]="true"
                      [style]="{'color': '#719eb6'}"
                      (ngModelChange)="onAnnotationDisplayChange(annotation, $event)"
                    />
                    <span class="ms-2" style="color: #719eb6">
                      {{ annotationLabel(annotation) }}
                    </span>
                  </div>
                  <div class="d-flex align-items-center">
                    @if (supportsLabelPosition(annotation)) {
                      <div class="annotation-label-position-control" role="group" aria-label="Label position">
                        <button
                          type="button"
                          [class.active]="currentLabelPosition(annotation) === 'start'"
                          (click)="onLabelPositionSelected(annotation, 'start')"
                          title="Move label toward the start of the annotation line"
                        >s</button>
                        <button
                          type="button"
                          [class.active]="currentLabelPosition(annotation) === 'middle'"
                          (click)="onLabelPositionSelected(annotation, 'middle')"
                          title="Center label on the annotation line"
                        >c</button>
                        <button
                          type="button"
                          [class.active]="currentLabelPosition(annotation) === 'end'"
                          (click)="onLabelPositionSelected(annotation, 'end')"
                          title="Move label toward the end of the annotation line"
                        >e</button>
                      </div>
                    }
                    <button class="btn btn-link p-0" [disabled]="true">
                      <i class="pi pi-pencil" style="color: #719eb6; opacity: 0.5"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          @if (userAnnotations().length > 0) {
            <div>
              <div class="fw-bold mb-1" style="color: #719eb6">Custom Annotations</div>
              @for(annotation of userAnnotations(); track $index) {
                <div class="d-flex align-items-center justify-content-between p-2 border-bottom">
                  <div class="d-flex align-items-center">
                    <p-checkbox
                      [ngModel]="isAnnotationDisplayed(annotation)"
                      [binary]="true"
                      [style]="{'color': '#719eb6'}"
                      (ngModelChange)="onAnnotationDisplayChange(annotation, $event)"
                    />
                    <span class="ms-2" style="color: #719eb6">
                      {{ annotationLabel(annotation) }}
                    </span>
                  </div>
                  <div class="d-flex align-items-center">
                    @if (supportsLabelPosition(annotation)) {
                      <div class="annotation-label-position-control" role="group" aria-label="Label position">
                        <button
                          type="button"
                          [class.active]="currentLabelPosition(annotation) === 'start'"
                          (click)="onLabelPositionSelected(annotation, 'start')"
                          title="Move label toward the start of the annotation line"
                        >s</button>
                        <button
                          type="button"
                          [class.active]="currentLabelPosition(annotation) === 'middle'"
                          (click)="onLabelPositionSelected(annotation, 'middle')"
                          title="Center label on the annotation line"
                        >c</button>
                        <button
                          type="button"
                          [class.active]="currentLabelPosition(annotation) === 'end'"
                          (click)="onLabelPositionSelected(annotation, 'end')"
                          title="Move label toward the end of the annotation line"
                        >e</button>
                      </div>
                    }
                    <button class="btn btn-link p-0" (click)="editAnnotation.emit(annotation)">
                      <i class="pi pi-pencil" style="color: #719eb6"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          @if (automaticAnnotations().length == 0 && userAnnotations().length == 0) {
            <div class="text-center p-3" style="color: #719eb6">
              No annotations available
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if(canAddAnnotation) {
    <div class="col-12">
      <button
        (click)="addAnnotation.emit()"
        class="side-menu-button2 selected w-100 mt-2"
        id="addAnnotationButton"
      >
        + Annotation
      </button>
    </div>
  }
  @if (showAnnotationDisplayOptions) {
    <div class="col-12 mt-2">
      <div class="control mb-2">
        <label for="annotationLabelBackgroundOption" style="font-weight: bold; color: #719eb6">Annotation Labels:</label>
        <p-dropdown
          id="annotationLabelBackgroundOption"
          [options]="annotationLabelBackgroundOptions"
          [ngModel]="annotationLabelBackground"
          (ngModelChange)="annotationLabelBackgroundChange.emit($event)"
          appendTo="body"
          styleClass="w-100"
          optionLabel="label"
          optionValue="value"
          [disabled]="isLoadingGraph"
          [loading]="isLoadingGraph"
          placeholder="Select annotation label background"
        />
      </div>
      <div class="d-flex align-items-start">
        <p-checkbox
          [ngModel]="declutterAnnotations"
          (ngModelChange)="declutterAnnotationsChange.emit($event)"
          [binary]="true"
          [style]="{'color': '#719eb6'}"
          inputId="declutterAnnotations"
          [disabled]="isLoadingGraph"
        />
        <div class="ms-2">
          <label for="declutterAnnotations" style="font-weight: bold; color: #719eb6">Declutter Annotations</label>
          <div class="declutter-hint">
            Assigns a unique color to each visible annotation, hides on-chart labels, and shows a legend so lines stay readable.
          </div>
        </div>
      </div>
    </div>
  }
</div>
